module.exports = __webpack_public_path__ + "img/425F84_1C2939_2A3F57_24344C-256px.171182e3.png";